import {useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {useNavigationHistory} from './NavigationHistoryProvider';

export function useGoForward() {
  const navigate = useNavigate();
  const {t} = useTranslation('common');
  const {canGoForward} = useNavigationHistory();

  const onClick = useCallback(() => navigate(1), [navigate]);
  return useMemo(
    () => ({onClick, ariaLabel: t('forward'), disabled: !canGoForward}),
    [onClick, t, canGoForward]
  );
}
